<template>
    <ValidationProvider
        v-slot="{ classes, errors }"
        ref="provider"
        :rules="rules"
        :custom-messages="customMessages"
        :name="name"
        class="w-full"
        :class="$attrs['class']"
        tag="div"
        mode="eager"
    >
        <div class="digi-input w-full" :class="classes">
            <label class="form-label font-inter font-bold text-viva-money-black" :for="name" v-html="errors[0] || label"></label>
            <div class="form-input -m-2">
                <div class="form-input-inner p-2 w-full">
                    <div class="input-wrapper w-full relative">
                        <EmailDropdown
                            ref="emailDropDown"
                            v-model="email"
                            :name="name"
                            :domains="domains"
                            :defaultDomains="defaultDomains"
                            @change="handleChange"
                            @input="handleInput"
                            inputClasses="textbox bg-white h-12 w-full border-viva-money-black border-2 focus:border-viva-money-secondary-yellow outline-none p-4 font-inter text-viva-money-black"
                            autocomplete="chrome-off"
                        />
                    </div>
                </div>
            </div>
            <div v-if="emailSuggestion" class="form-microtext mt-4 text-center font-inter text-viva-money-black">
                <small>Did you mean <a @click.prevent="acceptSuggestion" v-text="emailSuggestion"></a>?</small>
            </div>
        </div>
    </ValidationProvider>
</template>
 
<script>
import Mailcheck from "mailcheck";
// Import package
import EmailDropdown from "./email-dropdown";
import { has, isString, debounce } from "underscore/modules/index";
export default {
    components: {
        EmailDropdown,
    },
    data() {
        return {
            emailSuggestion: null,
            email: this.value,
            defaultDomains: [
                "gmail.com",
                "hotmail.co.uk",
                "hotmail.com",
                "outlook.com",
                "icloud.com",
                "yahoo.com",
                "yahoo.co.uk",
                "live.co.uk",
                "googelmail.com",
                "aol.com",
                "sky.com",
                "btinternet.com",
                "live.com",
                "mail.com",
                "msn.com",
                "me.com",
                "ymail.com",
                "aol.co.uk",
                "wp.pl",
                "ntlworld.com",
                "rocketmail.com",
                "talktalk.net",
                "virginmedia.com",
            ],
            domains: [
                "gmail.com",
                "hotmail.co.uk",
                "hotmail.com",
                "outlook.com",
                "icloud.com",
                "yahoo.com",
                "yahoo.co.uk",
                "live.co.uk",
                "googelmail.com",
                "aol.com",
                "sky.com",
                "btinternet.com",
                "live.com",
                "mail.com",
                "msn.com",
                "me.com",
                "ymail.com",
                "aol.co.uk",
                "wp.pl",
                "ntlworld.com",
                "rocketmail.com",
                "talktalk.net",
                "virginmedia.com",
            ],
        };
    },
    props: {
        rules: {
            default: () => {
                return {};
            },
        },
        customMessages: {
            default: () => {
                return {};
            },
        },
        attributes: {
            default: {},
        },
        value: {
            default: "",
        },
        name: {
            default: "",
        },
        label: {
            default: "",
        },
        options: {
            default: () => {
                return {};
            },
            type: Object,
        },
        valid: {
            default: null,
        },
        type: {
            default: "text",
        },
        containerClasses: {
            default: () => {
                return ["mb-8"];
            },
        },
    },
    created() {
        if (this.value) {
            this.$nextTick(() => {
                if (this.value) {
                    this.$refs.provider.validate(this.value);
                } else {
                    this.$refs.provider.reset();
                }
            });
        }
    },
    methods: {
        runSuggestion: debounce(function() {
            let self = this;
            Mailcheck.run({
                email: self.email,
                suggested(suggestion) {
                    if (suggestion.full !== self.email) {
                        self.emailSuggestion = suggestion.full;
                    } else {
                        self.emailSuggestion = null;
                    }
                },
                empty() {
                    self.emailSuggestion = null;
                }
            });
        }, 500),
        acceptSuggestion() {
            this.$nextTick(() => {
                this.email = this.emailSuggestion;
                this.$emit('input', this.email);
                this.emailSuggestion = null;
            });
        },
        handleInput(e) {
            let value = '';
            if (e.target && e.target.value) {
                value = e.target.value;
            } else if (isString(e)) {
                value = e;
            }
            this.$emit("input", value);
            this.runSuggestion();
        },
        handleChange(e) {
        },
    },
};
</script>
<style lang="scss">
.digi-email.valid {
    .textbox {
        box-shadow: inset 0 0 0 1px #F0BA46;
        border-color: #F0BA46;
        border-width: 1px;
    }
}

.digi-email.invalid {
    .textbox {
        box-shadow: inset 0 0 0 1px #FF6B6C;
        border-color: #FF6B6C;
        border-width: 1px;
    }
}
.email-dropdown-wrapper[data-v-3d11e900] {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
}
.email-dropdown-wrapper .input-button-wrapper[data-v-3d11e900] {
    position: relative;
    display: flex;
    flex-direction: row;
}
.email-dropdown-wrapper input[data-v-3d11e900] {
    text-overflow: ellipsis;
    width: 100%;
    padding-right: 0;
}
.email-dropdown-wrapper button[data-v-3d11e900] {
    padding: 0;
    margin-left: -11.8px;
    margin-right: 0;
    background: transparent;
    border: none;
    cursor: pointer;
    outline: none;
}
.email-dropdown-wrapper button[data-v-3d11e900]:focus {
    outline: none;
}
.email-dropdown-wrapper .email-dropdown-list-container[data-v-3d11e900] {
    position: relative;
    height: 0;
}
.email-dropdown-wrapper .email-dropdown-list-container.hide[data-v-3d11e900] {
    display: none;
}
.email-dropdown-wrapper .email-dropdown-list[data-v-3d11e900] {
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10000;
    background-color: #fff;
    overflow: hidden;
    list-style: none;
    margin: 0;
    padding: 0;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    border: 0.1px solid #D6D6D6;
    box-sizing: border-box;
    margin-top: -0.9px;
}
.email-dropdown-wrapper
    .email-dropdown-list
    .email-dropdown-item[data-v-3d11e900] {
    cursor: pointer;
    padding-left: 16px;
    padding: 16px;
}
.email-dropdown-wrapper
    .email-dropdown-list
    .email-dropdown-item[data-v-3d11e900]:first-child {
    border-top: none;
}
.email-dropdown-wrapper
    .email-dropdown-list
    .email-dropdown-item[data-v-3d11e900]:focus,
.email-dropdown-wrapper
    .email-dropdown-list
    .email-dropdown-item[data-v-3d11e900]:hover {
    background-color: #F7F7F7;
    border: 0.1px solid #a9a9a9;
    box-sizing: border-box;
}
.email-dropdown-wrapper
    .email-dropdown-list
    .email-dropdown-item-username[data-v-3d11e900] {
    color: #555;
}
.email-dropdown-wrapper
    .email-dropdown-list
    .email-dropdown-item-domain[data-v-3d11e900] {
    color: #555555;
    font-weight: 500;
}
</style>